import { render, staticRenderFns } from "./openstreetmap.vue?vue&type=template&id=72b21e09&"
import script from "./openstreetmap.vue?vue&type=script&lang=js&"
export * from "./openstreetmap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('72b21e09')) {
      api.createRecord('72b21e09', component.options)
    } else {
      api.reload('72b21e09', component.options)
    }
    module.hot.accept("./openstreetmap.vue?vue&type=template&id=72b21e09&", function () {
      api.rerender('72b21e09', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2DWSnXmS2WFG3/JS/comp/openstreetmap.vue"
export default component.exports